import React from 'react';
import styles from './InviteContainer.scss';

const TestDetails = ({ title, numProblems, time }) => (
  <div className={styles['c-invite__test-details']}>
    <h1 className="header-font-size font-weight-bold">{title}</h1>
    <p className="sub-header-font-size-mid">
      {numProblems} Questions {time} Minutes
    </p>
  </div>
);
export default TestDetails;
